module.exports = __webpack_public_path__ + "static/media/animalCiclo4.44169315.png";